import { addRefreshAuthToDataProvider, Admin, Resource } from "react-admin";

import { BrowserRouter } from "react-router-dom";

import { GroupCreate } from "entities/siteService/groups/create/GroupCreate";
import { GroupEdit } from "entities/siteService/groups/edit/GroupEdit";
import { GroupShow } from "entities/siteService/groups/show/GroupShow";

import { StatusEdit } from "entities/siteService/sites_statuses/StatusEdit";
import { StatusShow } from "entities/siteService/sites_statuses/StatusShow";

import { BidsList } from "entities/regelleistungService/bids/BidsList";

import PlanningMaskCreate from "entities/planningService/plannings_masks/PlanningMaskCreate";

import { getPermissionsFromAccount, loginRequest, MSALObj, tokenRequest } from "app/providers/auth/authConfig";
import combinedDataProvider from "app/providers/data/compositeDataProvider";
import { i18nProvider } from "app/providers/i18n/i18nProvider";
import ReTheme from "app/providers/theme";
import { parseISO } from "date-fns";
import AfrrEngagementVisualization from "entities/affrEngagementService/AfrrEngagementVisualization";
import { AfrrEngagementBidTimeserieShow } from "entities/affrEngagementService/bidTimeSeries/AfrrEngagementBidTimeserieShow";
import { AfrrEngagementBidTimeSeriesList } from "entities/affrEngagementService/bidTimeSeries/AfrrEngagementBidTimeSeriesList";
import AfrrEngagementPointList from "entities/affrEngagementService/points/AfrrEngagementPointList";

import AuthGate from "app/providers/auth/AuthGate";
import TestFingridCsvGeneration from "entities/csvGenerations/fingridCsvGeneration/TestFingridCsvGeneration";
import GenerationInitialForm from "entities/csvGenerations/performanceDagGeneration/InitialForm";
import CertificationRtePhase2 from "entities/csvGenerations/performancePhase2/CertificationRtePhase2";
import DeliveryDatePoints from "entities/ecpService/DeliveryDatePoints";
import EcpGateList from "entities/ecpService/gates/EcpGateList";
import EcpFcrVisualization from "entities/ecpService/visualization/EcpFcrVisualization";
import ConfigProtocolParametersCreate from "entities/finlandCommunication/ConfigProtocolParameters/ConfigProtocolParametersCreate";
import ConfigProtocolParametersList from "entities/finlandCommunication/ConfigProtocolParameters/ConfigProtocolParametersList";
import { MaintenanceCreate } from "entities/maintenancesService/MaintenancesCreate";
import { MaintenancesEdit } from "entities/maintenancesService/MaintenancesEdit";
import { MaintenancesList } from "entities/maintenancesService/MaintenancesList";
import { MaintenancesShow } from "entities/maintenancesService/MaintenancesShow";
import { EmaxHGateList } from "entities/mecapa/EmaxHGateList";
import { EmaxJGateList } from "entities/mecapa/EmaxJGateList";
import CertificationsCreate from "entities/optimizer/certifications/CertificationsCreate";
import CertificationsEdit from "entities/optimizer/certifications/CertificationsEdit";
import CertificationsList from "entities/optimizer/certifications/CertificationsList";
import CertificationsShow from "entities/optimizer/certifications/CertificationsShow";
import CertificationsTestsCreate from "entities/optimizer/certifications_tests/CertificationsTestsCreate";
import CertificationsTestsEdit from "entities/optimizer/certifications_tests/CertificationsTestsEdit";
import CertificationsTestsList from "entities/optimizer/certifications_tests/CertificationsTestsList";
import CertificationsTestsShow from "entities/optimizer/certifications_tests/CertificationsTestsShow";
import GroupCertificationsCreate from "entities/optimizer/groups_certifications/create/GroupCertificationsCreate";
import GroupsCertificationsEdit from "entities/optimizer/groups_certifications/edit/GroupsCertificationsEdit";
import GroupsCertificationsList from "entities/optimizer/groups_certifications/GroupsCertificationsList";
import OptiTasksList from "entities/optimizer/tasks/OptiTasksList";
import PlanningCreate from "entities/planningService/plannings/PlanningCreate";
import PlanningEdit from "entities/planningService/plannings/PlanningEdit";
import PlanningShow from "entities/planningService/plannings/PlanningShow";
import PlanningsList from "entities/planningService/plannings/PlanningsList";
import { PlanningMaskList } from "entities/planningService/plannings_masks/PlanningMaskList";
import BidsVizualization from "entities/regelleistungService/bids/BidsVizualization";
import RteCommunicationConfigList from "entities/rteCommunication/configs/RteCommunicationConfigList";
import RteCommunicationFakePaList from "entities/rteCommunication/fakePas/RteCommunicationFakePaList";
import RteCommunicationMarketConfigList from "entities/rteCommunication/marketConfigs/RteCommunicationMarketConfigList";
import RteCommunicationTestConfigList from "entities/rteCommunication/testConfigs/RteCommunicationTestConfigList";
import { GroupList } from "entities/siteService/groups/list/GroupList";
import PerformanceCreate from "entities/siteService/performances/performanceValidation/PerformanceCreate";
import PerformanceList from "entities/siteService/performances/performanceValidation/PerformanceList";
import TestSending from "entities/siteService/performances/testSending/TestSending";
import { SiteCreate } from "entities/siteService/sites/create/SiteCreate";
import { SiteEdit } from "entities/siteService/sites/edit/SiteEdit";
import { SiteShow } from "entities/siteService/sites/show/SiteShow";
import { StatusesSimpleList } from "entities/siteService/sites_statuses/StatusesSimpleList";
import StatusList from "entities/siteService/sites_statuses/StatusList";
import TopNiveauBidsCreate from "entities/topNiveauService/bids/TopNiveauBidsCreate";
import TopNiveauBidsEdit from "entities/topNiveauService/bids/TopNiveauBidsEdit";
import TopNiveauBidsList from "entities/topNiveauService/bids/TopNiveauBidsList";
import TopNiveauBidsShow from "entities/topNiveauService/bids/TopNiveauBidsShow";
import TopNiveauGatesCreate from "entities/topNiveauService/gates/TopNiveauGatesCreate";
import TopNiveauGatesEdit from "entities/topNiveauService/gates/TopNiveauGatesEdit";
import TopNiveauGatesList from "entities/topNiveauService/gates/TopNiveauGatesList";
import TopNiveauGatesShow from "entities/topNiveauService/gates/TopNiveauGatesShow";
import TestFingridFcrD from "entities/tsoTests/testsFingrid/fcrD/TestFingridFcrD";
import TestFingridFcrN from "entities/tsoTests/testsFingrid/fcrN/TestFingridFcrN";
import TestFingridAfrr from "entities/tsoTests/testsFingrid/fingridAfrr/TestFingridAfrr";
import TestsAfrrRteForm from "entities/tsoTests/testsRte/testsAfrrRte/TestsAfrrRteForm";
import TestFcrRte from "entities/tsoTests/testsRte/testsFcrRte/TestFcrRte";
import { msalAuthProvider, msalRefreshAuth } from "ra-auth-msal";
import { useEffect, useMemo, useState } from "react";
import {
  AfrrEngagementResourcesEnum,
  EcpResourcesEnum,
  FinlandCommunicationResourcesEnum,
  MaintenanceResourcesEnum,
  MecapaResourcesEnum,
  OptimizerResourcesEnum,
  PlanningResourcesEnum,
  RegelleistungResourcesEnum,
  RteCommunicationV2ResourcesEnum,
  SiteResourcesEnum,
  TestsFingridEnum,
  TestsRteResourcesEnum,
  TopNiveauResourcesEnum,
} from "shared/enums/resourceMappings";
import CustomSolarLayout from "./CustomSolarLayout";
import { SiteList } from "entities/siteService/sites/list/SitesList";
import { GroupsSitesList } from "entities/siteService/siteGroup/list/GroupsSitesList";
import { GroupSiteCreate } from "entities/siteService/siteGroup/create/GroupSiteCreate";
import { GroupsSitesEdit } from "entities/siteService/siteGroup/edit/GroupsSitesEdit";

const App = () => {
  const [isMSALInitialized, setMSALInitialized] = useState(false);
  const [authProvider, setAuthProvider] = useState<any | null>(null);
  const [dataProvider, setDataProvider] = useState<any | null>(null);

  const today = useMemo(() => new Date(), []);

  useEffect(() => {
    MSALObj.initialize().then(() => {
      setMSALInitialized(true);

      const authProvider = msalAuthProvider({
        msalInstance: MSALObj,
        loginRequest,
        tokenRequest,
        getPermissionsFromAccount,
        redirectOnCheckAuth: false,
      });
      setAuthProvider(authProvider);

      const dataProvider = addRefreshAuthToDataProvider(
        combinedDataProvider,
        msalRefreshAuth({
          msalInstance: MSALObj,
          tokenRequest,
        }),
      );
      setDataProvider(dataProvider);
    });
  }, []);

  if (!isMSALInitialized || !authProvider || !dataProvider) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <AuthGate instance={MSALObj}>
        <Admin
          theme={ReTheme}
          dataProvider={dataProvider}
          authProvider={authProvider as any}
          i18nProvider={i18nProvider}
          requireAuth
          layout={CustomSolarLayout}
          loginPage={false}
        >
          <Resource
            name={SiteResourcesEnum.Sites}
            options={{ label: "Site" }}
            list={SiteList}
            edit={SiteEdit}
            show={SiteShow}
            create={SiteCreate}
            recordRepresentation={(record) => {
              return `${record?.id} : ${record?.name}`;
            }}
          />
          <Resource
            name={SiteResourcesEnum.Statuses}
            options={{ label: "Statuts des sites" }}
            list={StatusList}
            show={StatusShow}
            edit={StatusEdit}
            recordRepresentation="name"
          />
          <Resource
            name={SiteResourcesEnum.StatusesV2}
            options={{ label: "Statuts V2 des sites" }}
            list={StatusesSimpleList}
            recordRepresentation="name"
          />
          <Resource
            name={SiteResourcesEnum.Groups}
            list={GroupList}
            show={GroupShow}
            edit={GroupEdit}
            create={GroupCreate}
            recordRepresentation={(record) => {
              return `${record?.id} : ${record?.name} - ${record?.code}`;
            }}
          />
          <Resource
            name={SiteResourcesEnum.Associations}
            list={GroupsSitesList}
            create={GroupSiteCreate}
            edit={GroupsSitesEdit}
          />
          <Resource name={SiteResourcesEnum.Telemetry1S} recordRepresentation="timestamp" />
          <Resource name={SiteResourcesEnum.NLevels} recordRepresentation="timestamp" />
          <Resource
            name={SiteResourcesEnum.PerformanceChronicles}
            list={PerformanceList}
            create={PerformanceCreate}
            options={{ label: "Config Validation" }}
          />
          <Resource
            name={SiteResourcesEnum.PerformanceChronicleGeneration}
            list={GenerationInitialForm}
            options={{ label: "Report Generation" }}
          />
          <Resource
            name={SiteResourcesEnum.PerformanceChronicleTestSending}
            list={TestSending}
            options={{ label: "Send MSI chronicle for JBox 2" }}
          />
          <Resource name={SiteResourcesEnum.PerformanceChronicleResults} />
          <Resource name={SiteResourcesEnum.SiteConfigurations} />
          <Resource
            name={SiteResourcesEnum.CertificationRtePhase2}
            list={CertificationRtePhase2}
            options={{ label: "RTE Phase 2" }}
          />
          <Resource name={SiteResourcesEnum.SiteExport} />
          <Resource name={SiteResourcesEnum.SiteUpload} />

          <Resource name={RegelleistungResourcesEnum.RegelleistungBids} options={{ label: "Bids" }} list={BidsList} />
          <Resource
            name={RegelleistungResourcesEnum.RegelleistungBidsVisualization}
            options={{ label: "Bids Visualization" }}
            list={BidsVizualization}
          />
          <Resource
            name={PlanningResourcesEnum.Plannings}
            options={{ label: "Plannings" }}
            list={PlanningsList}
            show={PlanningShow}
            edit={PlanningEdit}
            create={PlanningCreate}
            recordRepresentation={(record) => {
              return `site ${record?.site_id} : ${parseISO(record?.start_date)}`;
            }}
          />
          <Resource
            name={PlanningResourcesEnum.PlanningMasks}
            options={{ label: "Planning Masks" }}
            list={PlanningMaskList}
            create={PlanningMaskCreate}
          />
          <Resource
            name={MaintenanceResourcesEnum.Maintenance}
            options={{ label: "Maintenances" }}
            list={MaintenancesList}
            show={MaintenancesShow}
            edit={MaintenancesEdit}
            create={MaintenanceCreate}
            recordRepresentation="name"
          />
          <Resource
            name={OptimizerResourcesEnum.OptiCertificationsTests}
            list={CertificationsTestsList}
            show={CertificationsTestsShow}
            edit={CertificationsTestsEdit}
            create={CertificationsTestsCreate}
            options={{ label: "Certifications tests" }}
          />
          <Resource
            name={OptimizerResourcesEnum.OptiCertifications}
            list={CertificationsList}
            show={CertificationsShow}
            edit={CertificationsEdit}
            create={CertificationsCreate}
            recordRepresentation="certif_name"
            options={{ label: "Certifications" }}
          />
          <Resource
            name={OptimizerResourcesEnum.OptiGroupsCertifications}
            list={GroupsCertificationsList}
            edit={GroupsCertificationsEdit}
            create={GroupCertificationsCreate}
            options={{ label: "Groups Certifications" }}
          />
          <Resource name={OptimizerResourcesEnum.OptiTasks} list={OptiTasksList} options={{ label: "Opti Tasks" }} />
          <Resource
            name={AfrrEngagementResourcesEnum.Point}
            list={AfrrEngagementPointList}
            options={{ label: "Points" }}
          />
          <Resource
            name={AfrrEngagementResourcesEnum.Engagement}
            list={AfrrEngagementVisualization}
            options={{ label: "Engagement" }}
          />
          <Resource
            name={AfrrEngagementResourcesEnum.BidTimeSeries}
            list={AfrrEngagementBidTimeSeriesList}
            show={AfrrEngagementBidTimeserieShow}
          />
          <Resource
            name={TopNiveauResourcesEnum.TopNiveauBids}
            list={TopNiveauBidsList}
            show={TopNiveauBidsShow}
            edit={TopNiveauBidsEdit}
            create={TopNiveauBidsCreate}
            options={{ label: "Top Niveau Bids" }}
          />
          <Resource
            name={TopNiveauResourcesEnum.TopNiveauGates}
            list={TopNiveauGatesList}
            show={TopNiveauGatesShow}
            edit={TopNiveauGatesEdit}
            create={TopNiveauGatesCreate}
            options={{ label: "Top Niveau Gates" }}
          />
          <Resource
            name={EcpResourcesEnum.EcpReservePlanGates}
            list={EcpGateList}
            options={{ label: "ECP Reserve Plan Gates" }}
          />
          <Resource
            name={EcpResourcesEnum.EcpReservePlanPoints}
            list={DeliveryDatePoints}
            options={{ label: "ECP Reserve Plan Points" }}
          />
          <Resource
            name={EcpResourcesEnum.EcpFcrDVisualization}
            list={<EcpFcrVisualization businessType="fcr_d" deliveryDate={today} />}
            options={{ label: "ECP FCR D Visualization Chart" }}
          />
          <Resource
            name={EcpResourcesEnum.EcpFcrNVisualization}
            list={<EcpFcrVisualization businessType="fcr_n" deliveryDate={today} />}
            options={{ label: "ECP FCR N Visualization Chart" }}
          />

          <Resource
            name={RteCommunicationV2ResourcesEnum.RteCommunicationConfig}
            list={RteCommunicationConfigList}
            options={{ label: "Tranches TM" }}
          />
          <Resource
            name={RteCommunicationV2ResourcesEnum.RteCommunicationFakePa}
            list={RteCommunicationFakePaList}
            options={{ label: "Fake PA" }}
          />
          <Resource
            name={RteCommunicationV2ResourcesEnum.RteCommunicationTestConfig}
            list={RteCommunicationTestConfigList}
            options={{ label: "Test Configurations" }}
          />
          <Resource
            name={RteCommunicationV2ResourcesEnum.RteCommunicationMarketConfig}
            list={RteCommunicationMarketConfigList}
            options={{ label: "Market Configurations" }}
            recordRepresentation={(record) => {
              return `EDR ${record?.edr_id} - ${record?.market}`;
            }}
          />

          <Resource
            name={TestsRteResourcesEnum.TestsAfrrRte}
            list={TestsAfrrRteForm}
            options={{ label: "Tests AFRR RTE" }}
          />
          <Resource name={TestsRteResourcesEnum.TestsFcrRte} list={TestFcrRte} options={{ label: "Tests FCR RTE" }} />

          <Resource
            name={FinlandCommunicationResourcesEnum.ConfigProtocolParameters}
            list={<ConfigProtocolParametersList />}
            create={<ConfigProtocolParametersCreate />}
            options={{ label: "Config Protocol Parameters" }}
          />
          <Resource
            name={TestsFingridEnum.TestFingridFcrN}
            list={TestFingridFcrN}
            options={{ label: "Tests Fingrid FCR-N" }}
          />
          <Resource
            name={TestsFingridEnum.TestFingridFcrD}
            list={TestFingridFcrD}
            options={{ label: "Tests Fingrid FCR-D" }}
          />
          <Resource
            name={TestsFingridEnum.TestFingridAfrr}
            list={TestFingridAfrr}
            options={{ label: "Tests Fingrid AFRR" }}
          />
          <Resource
            name={TestsFingridEnum.TestFingridCsvGeneration}
            list={TestFingridCsvGeneration}
            options={{ label: "Génération CSV Fingrid" }}
          />
          <Resource name={MecapaResourcesEnum.EmaxHGates} list={EmaxHGateList} options={{ label: "Emax H Gates" }} />
          <Resource name={MecapaResourcesEnum.EmaxJGates} list={EmaxJGateList} options={{ label: "Emax J Gates" }} />
        </Admin>
      </AuthGate>
    </BrowserRouter>
  );
};

export default App;
